<ng-container *ngIf="hasAvailableData || (kpis$ | async).length > 0">
  <agr-summary-card
    title="{{ 'farmer-insights.kpis.' + kpi | translate }}"
    class="spacing--margin-all"
    *ngFor="let kpi of kpis$ | async"
  >
    <agr-chart
      *ngIf="getData(kpi) !== undefined"
      [options]="getOptions(kpi)"
      [dataSource]="getData(kpi)"
    ></agr-chart>
  </agr-summary-card>
</ng-container>

<agr-notification-empty
  [isEmpty]="!hasAvailableData || (kpis$ | async).length === 0"
></agr-notification-empty>
